type LogMethod = (message: string, ...args: unknown[]) => void

interface Logger {
  error: LogMethod
  warn: LogMethod
  info: LogMethod
  debug: LogMethod
}

const createLogMethod = (method: 'error' | 'warn' | 'info' | 'debug'): LogMethod => {
  return (message: string, ...args: unknown[]) => {
    if (method === 'error' || method === 'warn') {
      console[method](message, ...args)
    } else if (import.meta.env.DEV) {
      console[method](message, ...args)
    }
  }
}

export const logger: Logger = {
  error: createLogMethod('error'),
  warn: createLogMethod('warn'),
  info: createLogMethod('info'),
  debug: createLogMethod('debug'),
}
